import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/my-bookings")({
  component: MyBookingsLayout,
})

function MyBookingsLayout() {
  return <Outlet />
}
